import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { FullWidthSpinner } from './loader-components';
import { decodeTableInfoHash } from './TelegramApp/utils';
import { wait } from '../utils/general-utils';

const DEFAULT_REDIRECT_URL = 'https://t.me/SwensensBot';

export function getRedirectURL(tableInfo) {
    console.log('Preparing redirect for table:', tableInfo);
    // Replace this placeholder with an API call using tableInfo.outlet and tableInfo.table.
    return wait(250).then(() => DEFAULT_REDIRECT_URL);
}

export default function Redirect() {
    useEffect(() => {
        let active = true;
        let tableInfo;
        try {
            tableInfo = decodeTableInfoHash(window.location.hash);
            console.log('Redirect Table Result:', tableInfo);
        } catch (error) {
            console.warn('Unable to decode redirect table information:', error);
        }

        getRedirectURL(tableInfo)
            .catch(error => {
                console.error('Unable to resolve redirect URL:', error);
                return DEFAULT_REDIRECT_URL;
            })
            .then(url => {
                if (active) {
                    console.log('Redirecting to:', url);
                    window.location.replace(url);
                }
            });

        return () => { active = false; };
    }, []);

    return (
            <FullWidthSpinner
                text='Please wait...'
                heightInVH={isMobile ? 74 : 100}
                scale={3} />
    )

    // return (
    //     <>
    //         Loading...
    //     </>
    // )
}
